import { render } from "./Voltage.vue?vue&type=template&id=8e235ef2"
import script from "./Voltage.vue?vue&type=script&lang=js"
export * from "./Voltage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Gitlab-Runner\\builds\\bssYrz32\\0\\as\\WebServerVisualization\\webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__